import apiFetch from '@wordpress/api-fetch';

import { SelectOption } from '../../../core/components/form-item/form-item-types';
import { WPMeta } from '../../../core/types/core-types';
import { API_ROUTE_BASE } from '../../../core/utils/variables';

import { Employee, EmployeeDepartment } from './employee-types';

export const getEmployees = async (data: {
  search?: string;
  limit?: number;
  divisions?: string[];
  departments?: string[];
  employees?: string[];
}) => {
  const response = await apiFetch<Employee[]>({
    path: `${API_ROUTE_BASE}/employee/html`,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: { ...data, lang: document.documentElement.lang },
  });

  return response;
};

// export const getResult = async (data: EmployeeData) => {
//   const response = await apiFetch<FindWpPostsResult<Employee>>({
//     path: `${API_ROUTE_BASE}/employee/html`,
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     data: { ...data, lang: document.documentElement.lang },
//   });

//   return response;
// };

export const fetchEmployeeList = async () => {
  const result = await apiFetch<Employee[]>({
    path: `${API_ROUTE_BASE}/employee/list/`,
  });

  return result;
};

export const fetchEmployeeDivisions = async () => {
  const result = await apiFetch<WPMeta[]>({
    path: `${API_ROUTE_BASE}/employee/division/`,
  });

  return result.map<SelectOption>(({ name, id }) => ({
    label: name,
    value: id.toString(),
  }));
};

export const fetchEmployeeDepartments = async (data: {
  divisionId?: number;
}) => {
  const result = await apiFetch<EmployeeDepartment[]>({
    path: `${API_ROUTE_BASE}/employee/department/`,
    method: 'POST',
    data: { ...data, lang: document.documentElement.lang },
  });

  return result.map<SelectOption>(({ name, id }) => ({
    label: name,
    value: id.toString(),
  }));
};
